import { DATA_CONSTANTS } from 'martel-validator'
import SCHEMA_PROPS from '../../../node_modules/martel-validator/dist/SchemaProps'
import * as FIELD_CONSTANTS from '../mappings/FIELD_CONSTANTS'
import TRANSLATIONS from '../../translations'
import VALIDATION_RULES from '../mappings/validationRules'
import * as FormTypes from '../classes/FormTypes'

const DC_FVM = DATA_CONSTANTS.FIELD_VALUE_MAP('oneMkto')
const DC_SAM = DATA_CONSTANTS.STATE_ABBREVIATION_MAP
const DC_FIELDS = DATA_CONSTANTS.FIELDS('oneMkto')
const MARTEL_SCHEMA_PROPS = SCHEMA_PROPS('oneMkto')

let locale = ""

/**
 * Builds and returns schema object
 * @param lang
 * @returns {{fields: *, config: *, states: Array}}
 */
export default function getFormSchema(lang, formType){
    locale = lang

    return {
        //builds a new object consisting of field name and initial blank value, empty array for multifields
        fields: getFieldList(formType),

        //configuration for each field lives here, including dropdown options and labels
        config: getConfiguration(formType),

        //state map to country
        states: getStates(),

        //catch configuration specified in rules
        additionalConfig: {},

        //submissionData
        submissionData: {}
    }
}

/**
 *
 * @returns {*}
 */
function getFieldList(formType){
    let fieldList = DC_FIELDS.reduce(function(obj, item){

        //set to empty object if multi select
        let defaultVal = (item === "Primary_Product_Interest__c") ? [] : ""

        //set to defaultVal
        obj[item] = defaultVal

        return obj
    }, {})
    return {...fieldList, ...FormTypes.getTypeFields(formType)}
}

/**
 *
 * @returns {*}
 */
function getConfiguration(formType){
    let fieldConfig = DC_FIELDS.reduce(function(obj, item){
        obj[item] = {

            //look up field label, assign self if none found
            label: (item in FIELD_CONSTANTS.FIELD_LABEL_MAP) ? FIELD_CONSTANTS.FIELD_LABEL_MAP[item] : item,

            //look up maxlength from shcema props, assign blank if none found
            maxlength: (MARTEL_SCHEMA_PROPS.hasOwnProperty(item)) ? MARTEL_SCHEMA_PROPS[item].maxLength : "",

            //look up options from martel list
            options: getOptions(item),

            //show all fields by default
            show: true,

            //to match marketo, uppercase first character of the martel slug
            id: item.charAt(0).toUpperCase() + item.slice(1),

            //assign input name
            name: item,

            //validation rules
            validation: getValidationRules(item),

            //helper to add css rules to different states
            stateClass: {
                error: false,
                hasValue: false,
            },

            domElements: {}
        }

        //bind the required class to the dom
        obj[item].domElements.requiredIndicator = obj[item].validation.required ? "*" : ""

        return obj
    }, {})
    return {...fieldConfig, ...FormTypes.getTypeFieldsSchema(formType)}
}

/**
 *
 * @param item
 * @returns {{requred: boolean}}
 */
function getValidationRules(item){
    let rules = Object.assign({}, VALIDATION_RULES["global"], VALIDATION_RULES[item])

    return rules
}

/**
 * Returns country list with value-label state options for easier lookup and rendering on country change
 * @returns {Array}
 */
function getStates(){
    let arr = {}
    for(let c in FIELD_CONSTANTS.ABBREVIATION_TO_COUNTRY){
        arr[c] = getStateList(FIELD_CONSTANTS.ABBREVIATION_TO_COUNTRY[c])
    }
    return arr
}


/**
 * Helper for getStates() to built states list with value-label pair
 * @param country
 */
function getStateList(country){
    let arr = {}, c
    if(country in DC_SAM){
        for(c in DC_SAM[country]){
            arr[DC_SAM[country][c].toUpperCase()] = toTitleCase(c)
        }
    }else{
        for(c in DC_FVM["state_"+country]){
            arr[DC_FVM["state_"+country][c]] = DC_FVM["state_"+country][c]
        }
    }
    return arr
}


/**
 * Converts field names to title case for id, follows marketo standard
 *
 * @param str
 * @returns {string | *}
 */
function toTitleCase(str) {

    str = str.split(' ')
    for (let i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1)
    }
    return str.join(' ')
}


/**
 * Lookup for dropdown options, creates a value-label pair and adds blank value first
 * @param item
 * @returns {Object}
 */
function getOptions(item){
    if(DC_FVM[item] || FIELD_CONSTANTS.YES_NO_INPUTS.includes(item)){
        //get translation options, if none return from martel validator
        let options = getTranslationOptions(item)

        //re order country list to place USA at top
        if(item === 'country'){
            options.splice(options.indexOf("USA"), 1)
            options.unshift("USA")
        }

        //add blank option in first position
        options.unshift("")

        return options
    }
}

/**
 * lookup options from translation files, if none exist use martel validator list
 * @param item
 * @returns {T[] | SharedArrayBuffer | BigUint64Array | Uint8ClampedArray | Uint32Array | Blob | Int16Array | Float64Array | Float32Array | string | Uint16Array | ArrayBuffer | Int32Array | BigInt64Array | Uint8Array | Int8Array}
 */
function getTranslationOptions(item){

    // attempt to get the key from the translation file
    let key = TRANSLATIONS[locale].message.fields[item]

    //if the item exists, return the options otherwise return values from martel validator
    if(key){
        return (key.options) ? key.options : DC_FVM[item].slice(0)
    }
    return DC_FVM[item].slice(0)
}
